/**
 * Chế độ vận hành của phòng khám (ADR-0048).
 *
 * Some clinics keep their existing HIS as the system of record and use Addy only for the patient
 * channel. For them the clinical, pharmacy, billing, vaccination and reporting areas are not merely
 * unused — an encounter or an invoice created here is a record the real HIS never hears about.
 *
 * The server sends the module list rather than the console deriving it from the mode. One rule, in
 * one place: the same list drives the menu here and the 409 there, so they cannot disagree.
 */
import { apiClient } from "./client";

export type OperatingMode = "FULL_HIS" | "PATIENT_CHANNEL";

export type OperatingModule =
  | "ENCOUNTERS"
  | "PRESCRIPTIONS"
  | "INVENTORY"
  | "BILLING"
  | "VACCINATION"
  | "REPORTS";

export interface OperatingModeView {
  mode: OperatingMode;
  note: string | null;
  /** The modules this clinic operates inside Addy. */
  modules: OperatingModule[];
}

export interface OperatingModeRequest {
  mode: OperatingMode;
  note?: string | null;
}

export const operatingModeApi = {
  get(): Promise<OperatingModeView> {
    return apiClient.get<OperatingModeView>("/v1/clinic/operating-mode").then((r) => r.data);
  },
  update(req: OperatingModeRequest): Promise<OperatingModeView> {
    return apiClient.put<OperatingModeView>("/v1/clinic/operating-mode", req).then((r) => r.data);
  },
};

export const operatingModeQueryKeys = {
  current: () => ["clinic", "operating-mode"] as const,
};

export const OPERATING_MODE_LABELS: Record<OperatingMode, string> = {
  FULL_HIS: "Addy HIS là hệ thống chính",
  PATIENT_CHANNEL: "Chỉ kênh bệnh nhân (HIS khác là hệ thống chính)",
};

export const OPERATING_MODULE_LABELS: Record<OperatingModule, string> = {
  ENCOUNTERS: "Khám bệnh",
  PRESCRIPTIONS: "Đơn thuốc",
  INVENTORY: "Tồn kho",
  BILLING: "Hoá đơn & Thu chi",
  VACCINATION: "Tiêm chủng",
  REPORTS: "Báo cáo",
};
